import { defineMessages } from "react-intl"

export default defineMessages({
  title: {
    id: "app.components.Contact.title",
  },
  description: {
    id: "app.components.Contact.description",
  },
  firstname: {
    id: "app.components.Contact.firstname"
  },
  firstnamePlaceholder: {
    id: "app.components.Contact.firstnamePlaceholder"
  },
  lastname: {
    id: "app.components.Contact.lastname"
  },
  lastnamePlaceholder: {
    id: "app.components.Contact.lastnamePlaceholder"
  },
  email: {
    id: "app.components.Contact.email"
  },
  emailPlaceholder: {
    id: "app.components.Contact.emailPlaceholder"
  },
  subject: {
    id: "app.components.Contact.subject"
  },
  subjectPlaceholder: {
    id: "app.components.Contact.subjectPlaceholder"
  },
  message: {
    id: "app.components.Contact.message"
  },
  messagePlaceholder: {
    id: "app.components.Contact.messagePlaceholder"
  },
  send: {
    id: "app.components.Contact.send"
  },
  confirmationSuccess: {
    id: "app.components.Contact.confirmationSuccess"
  },
  confirmationFail: {
    id: "app.components.Contact.confirmationFail"
  },
  RECAPTCHA_MISSING: {
    id: "app.components.Contact.recaptcha",
  }
})
